import { useEffect } from 'react';
import { Flex } from 'rebass';

import LoadingOverlay from '@/components/LoadingOverlay';
import useAuth from '@/hooks/useAuth';

const Login = () => {
  const { login } = useAuth();
  useEffect(() => {
    setTimeout(() => {
      login({ redirectUri: `${document.location.origin}/auth?page=Target` });
    }, 3000);
  });
  return (
    <Flex
      justifyContent={['center', 'center', 'center']}
      height={['100%', '100%', '100%']}
      width={['100%', '100%', '100%']}
    >
      <LoadingOverlay status="loading" loadOnMount />
    </Flex>
  );
};

export default Login;
